module.exports = "../../app/cells/pages/landing_xray/index/overview_cell.rb";